module.exports = "<div class=\"container error\">\r\n  <h2 class=\"error-status\">Looking for something?</h2>\r\n  <p class=\"error-message\">We're sorry. The web page you entered is not a functioning page on our application.</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/unauthorized/unauthorized.component.html
// module id = ./src/app/shared/components/unauthorized/unauthorized.component.html
// module chunks = main